// ============================================================================
// APPLICATION ENDPOINTS
// ============================================================================
// Endpoint definitions for Application Management module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for application endpoints
 */
const BASE_PATH = '/application';

/**
 * Application Endpoints
 */
export const applicationEndpoints = {
  /**
   * Get all applications
   * GET /application
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get application by ID
   * GET /application/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Create new application
   * POST /application
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update application
   * PUT /application/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete application
   * DELETE /application/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

/**
 * Export endpoints
 */
export default applicationEndpoints;
